module.exports = __webpack_public_path__ + "img/mfa_sample.927aae8b.png";